/* The 27px square a list toolbar's controls sit in, on both screens that have one.
 *
 * A stylesheet with no component, like `emberButton.module.css` and `toolbarControl.module.css`
 * beside it: a component would have to take the glyph, the label and the pressed state as props,
 * and those differ per control while the SQUARE does not.
 *
 * ── Why it is shared (17.09.2026) ────────────────────────────────────────────────────────────
 * The plan library drew it first, on `--h-pl-control`; the exercise library draws two of them — the
 * filter trigger and the preview-panel toggle — at the same size, the same chip fill, the same
 * hairline and the same 9px radius, because the KANON specimen for `/cwiczenia` transcribes the
 * Programy toolbar verbatim. Three copies of one declaration block differing by nothing is exactly
 * what the house rule exists to prevent.
 *
 * ── What it does NOT own ─────────────────────────────────────────────────────────────────────
 * The PRESSED state. The filter trigger has none — a popup is open or it is not, and Base UI says
 * so — while the panel toggle is `aria-pressed` and carries the inset fill the specimen draws for
 * it. That is one screen's own treatment and it stays in that screen's stylesheet, against the ink
 * and tint named here.
 *
 * Anything positional belongs to the toolbar around it. */

.square {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: var(--h-pl-control);
  height: var(--h-pl-control);
  color: var(--text-2);
  background: var(--bg-chip);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-mark);
  cursor: pointer;
  transition-duration: var(--dur-fast);
  transition-property: color;
  transition-timing-function: var(--ease);
}

.square:hover {
  color: var(--text);
}

.square:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

/* The glyph inside it. 13.5px on both screens — the specimen's own `.mb-filter svg`. */
.icon {
  display: block;
  flex: none;
  width: 13.5px;
  height: 13.5px;
}

/* The mark that says a facet is narrowing the list. The ONE accent on a toolbar, and it is a state
 * rather than an action — which is why it is a dot and not a fill. */
.dot {
  position: absolute;
  top: var(--space-1);
  right: var(--space-1);
  width: 5.5px;
  height: 5.5px;
  background: var(--primary-fill);
  border: var(--border-thick) solid var(--bg-chip);
  border-radius: var(--r-pill);
}
